<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="card">
            <div class="tab-content">
                <div class="tab-pane active" id="Product">
                    <form @submit.prevent="handleSubmit()">
                        <div class="body">
                            <div class="media">
                                <div class="media-left m-r-20" v-if="imageSrc">
                                    <img
                                        :src="imageSrc"
                                        class="user-photo media-object"
                                        alt="User"
                                    />
                                </div>
                                <div class="media-body">
                                    <label>เพิ่มรูปภาพสินค้า</label>
                                    <div
                                        class="tw-text-xs tw-text-gray-500 col-12 mb-2 p-0"
                                    >
                                        <span
                                            >Recommended : 1920x1080 pixels,
                                            1280x720 pixels, 1080x1080
                                            pixels</span
                                        >
                                    </div>
                                    <button
                                        type="button"
                                        class="btn btn-default"
                                        id="btn-upload-photo"
                                        @click="uploadImage"
                                    >
                                        อัพโหลด
                                    </button>
                                    <input
                                        type="file"
                                        id="filePhoto"
                                        @change="onFileChange"
                                        class="sr-only"
                                        :required="!imageSrc"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="body">
                            <div class="row clearfix">
                                <div class="col-lg-6 col-md-12">
                                    <div class="form-group">
                                        <label class="tw-ml-2"
                                            >ชื่อสินค้า</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="ชื่อสินค้า"
                                            v-model="form.name"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="col-lg-3 col-6">
                                    <div class="form-group">
                                        <label class="tw-ml-2">ราคาขาย</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            class="form-control"
                                            placeholder="ราคาขาย"
                                            v-model="form.price"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="col-lg-3 col-6">
                                    <div class="form-group">
                                        <label class="tw-ml-2">ราคาปกติ</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            class="form-control"
                                            placeholder="ราคาปกติ"
                                            v-model="form.price_full"
                                            :min="form.price"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label class="tw-ml-2"
                                            >รายละเอียด</label
                                        >
                                        <trumbowyg
                                        v-model="form.description"
                                        :config="config"
                                        svgPath="/vendor/trumbowyg/dist/ui/icons.svg"
                                        ></trumbowyg>
                                        <!-- <count-character
                                            :text="form.description"
                                            :maxText="200"
                                        ></count-character>
                                        <textarea
                                            class="form-control"
                                            rows="5"
                                            cols="30"
                                            maxlength="200"
                                            required
                                            placeholder="รายละเอียดสินค้า"
                                            v-model="form.description"
                                        ></textarea> -->
                                    </div>

                                    <div class="mt-2">
                                        <label class="tw-ml-2"
                                            >เลือกหมวดหมู่</label
                                        >
                                        <Select2
                                            v-model="form.categories"
                                            :options="this.categories"
                                            :settings="{ multiple: true }"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="body">
                            <div class="tw-w-full text-right">
                                <button class="btn btn-sm btn-success">
                                    บันทึก
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-default tw-ml-1"
                                    @click="back()"
                                >
                                    ย้อนกลับ
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Select2 from "v-select2-component";
import configTextEditor from "../salepages/_config_texteditor.js";

export default {
    // props: ["shop", "is_edit"],
    props: {
        shop: {
            default: "",
            type: String,
            required: true
        },
        is_edit: {
            default: "",
            type: Boolean,
            required: true
        },
        product_id: {
            default: "",
            required: false
        },
        categories: {
            default: [],
            type: Array,
            require: false
        }
    },
    data() {
        return {
            loading: false,
            imageSrc: "",
            image: null,
            imageDir: "/product",
            form: {},
            config: configTextEditor
        };
    },
    mounted() {
        this.getDataEdit();
    },
    components: { Select2 },
    methods: {
        getDataEdit() {
            if (this.is_edit && this.product_id) {
                axios
                    .get(`/ajax/s/${this.shop}/products/${this.product_id}`)
                    .then(res => {
                        this.imageSrc = res.data.product.image_url;
                        this.form = res.data.product;
                        this.form.categories = res.data.categories;
                    });

            }
        },
        handleSubmit() {
            this.loading = true;
            if (this.is_edit) {
                this.update();
            } else {
                this.store();
            }
        },
        async update() {
            this.loading = true;
            let formData = new FormData();
            formData.append("name", this.form.name);
            formData.append("price", this.form.price);
            formData.append(
                "price_full",
                this.form.price_full ? this.form.price_full : ""
            );
            formData.append("description", this.form.description);
            formData.append("image", this.image ? this.image : "");
            formData.append("_method", "PATCH");
            formData.append("categories", JSON.stringify(this.form.categories));

            await axios
                .post(
                    `/backend/s/${this.shop}/products/${this.product_id}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                )
                .then(res => {
                    this.back();
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "กรุณาใส่ข้อมูลให้ครบถ้วน"
                    );

                    this.loading = false;
                });
        },
        async store() {
            if (this.image) {
                let formData = new FormData();
                formData.append("name", this.form.name);
                formData.append("price", this.form.price);
                formData.append("price_full", this.form.price_full);
                formData.append("description", this.form.description);
                formData.append("image", this.image);
                formData.append("categories", JSON.stringify(this.form.categories));
    
                await axios
                    .post(`/backend/s/${this.shop}/products`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        this.back();
                        this.loading = false;
                    })
                    .catch(err => {
                        this.messageAlert(
                            "error",
                            "Sorry",
                            "กรุณาใส่ข้อมูลให้ครบถ้วน"
                        );

                        this.loading = false;
                    });
            } else {
                this.messageAlert("error", "Sorry", "กรุณาใส่ข้อมูลให้ครบถ้วน");
                this.loading = false;
            }
        },
        async storeImage() {
            let formData = new FormData();
            formData.append("image", this.image ? this.image : "");
            formData.append("imageDir", this.imageDir);

            await axios
                .post(`/ajax/s/${this.shop}/upload-image`, formData)
                .then(res => {
                    this.form.image = res.data.imageUrl;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "เกิดข้อผิดพลาด",
                        "กรุณาลองใหม่อีกครั้ง"
                    );
                });
        },
        back() {
            window.location.href = `/backend/s/${this.shop}/products`;
        },
        uploadImage() {
            document.getElementById("filePhoto").click();
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }

            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                );
            } else {
                this.image = files[0];
                this.previewImage(files[0]);
            }
        },
        previewImage(file) {
            this.imageSrc = URL.createObjectURL(file);
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.media {
    @media (min-width: 0px) and (max-width: 992px) {
        width: 100%;
        flex-flow: column;
        flex-direction: column-reverse;
    }
}
.media-left {
    img {
        width: 100%;
        max-width: 200px;
    }
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
    }
}
</style>
